const config = {
	path: '//s.sermo.com',
	munchkinId: '239-PZX-356'
};
let arrayify = getSelection.call.bind([].slice);

/* eslint-disable no-unused-vars, no-undef */

/*
 * @author Sanford Whiteman
 * @version v1.106 2020-04-04
 * @copyright © 2020 Sanford Whiteman
 * @license Hippocratic 2.1: This license must appear with all reproductions of this software.
 * https://codepen.io/figureone/pen/dLqxPG
 * Create a completely barebones, user-styles-only Marketo form
 * by removing inline STYLE attributes and disabling STYLE and LINK elements
 */
function destyleMktoForm(mktoForm, moreStyles) {
	let form = mktoForm.getFormElem()[0],
		arrayFrom = getSelection.call.bind([].slice);

	// remove element styles from <form> and children
	let styledEls = arrayFrom(form.querySelectorAll('[style]')).concat(form);
	styledEls.forEach(function(el) {
		el.removeAttribute('style');
	});

	// disable remote stylesheets and local <style>s
	let styleSheets = arrayFrom(document.styleSheets);
	styleSheets.forEach(function(ss) {
		if ([mktoForms2BaseStyle, mktoForms2ThemeStyle].indexOf(ss.ownerNode) != -1 || form.contains(ss.ownerNode)) {
			//console.log('Marketo destyle: removing', ss);
			ss.disabled = true;
		} else {
			// console.log('Marketo destyle: ignoring', ss);
		}
	});
	if (!moreStyles) {
		form.setAttribute('data-styles-ready', 'true');
	}
}

function addRowClasses (mktoForm) {
	let form = mktoForm.getFormElem()[0],
		rows = form.querySelectorAll('.mktoFormRow');
	if (!rows.length) return;
	for (let row of rows) {
		if (!row.querySelector('textarea')) continue;
		row.classList.add('has-textarea');
	}
}

function addWrapClasses (mktoForm) {
	let form = mktoForm.getFormElem()[0],
		wraps = form.querySelectorAll('.mktoFieldWrap');
	if (!wraps.length) return;
	for (let wrap of wraps) {
		if (!wrap.querySelector('input[type="checkbox"]')) continue;
		wrap.classList.add('has-checkbox');
	}
}

// solve for using the same form multiple times
// adapted from https://codepen.io/figureone/pen/ayKadR
function randomizeInputIds (mktoForm) {
	let formEl = mktoForm.getFormElem()[0],
		rando = '_' + new Date().getTime() + Math.random();

	arrayify(formEl.querySelectorAll('label[for]')).forEach(function(labelEl) {
		var forEl = formEl.querySelector('[id="' + labelEl.htmlFor + '"]');
		if (forEl) {
			labelEl.htmlFor = forEl.id = forEl.id + rando;
		}
	});
}

// adapted from https://nation.marketo.com/t5/product-discussions/pulling-field-from-one-form-to-another/m-p/199967/highlight/true#M145612
function populateFromHash (mktoForm) {
	const hash = document.location.hash.substring(1);
	if (!hash) return;
	const fields = JSON.parse(decodeURIComponent(hash));
	mktoForm.setValues(fields);
}

function multipleFormInstances(mktoId) {
	let formEls = document.querySelectorAll(`[data-mkto-instance='${mktoId}']`);
	if (!formEls.length) return;
	formEls = arrayify(formEls);
	let loadForm = MktoForms2.loadForm.bind(MktoForms2, config.path, config.munchkinId, mktoId);

	MktoForms2.whenRendered(function(mktoForm) {
		if (mktoForm.getId() !== mktoId) return;
		randomizeInputIds(mktoForm);
	});

	(function loadFormCb(formEls) {
		var formEl = formEls.shift();
		formEl.id = 'mktoForm_' + mktoId;

		loadForm(function(form) {
			formEl.id = '';
			if (formEls.length) {
				loadFormCb(formEls);
			}
		});
	})(formEls);
}
/* eslint-enable no-unused-vars, no-undef */

export {config, arrayify, destyleMktoForm, addRowClasses, addWrapClasses, randomizeInputIds, populateFromHash, multipleFormInstances};
